var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocaccessibilityActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.98706H6C5.46957 2.98706 4.96086 3.19777 4.58579 3.57285C4.21071 3.94792 4 4.45663 4 4.98706V20.9871C4 21.5175 4.21071 22.0262 4.58579 22.4013C4.96086 22.7763 5.46957 22.9871 6 22.9871H18C18.5304 22.9871 19.0391 22.7763 19.4142 22.4013C19.7893 22.0262 20 21.5175 20 20.9871V8.98706L14 2.98706Z",
    stroke: "#0D062D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.98706V8.98706H20",
    stroke: "#0D062D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.9871H8",
    stroke: "#0D062D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17.9871H8",
    stroke: "#0D062D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.98706H9H8",
    stroke: "#0D062D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocaccessibilityActive);
export default __webpack_public_path__ + "static/media/docaccessibility-active.a0c0876dc2bdf9f1ce88c18cd74f641c.svg";
export { ForwardRef as ReactComponent };